// routes/survey.$formId.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/survey.$formId')

export const handle = { name: 'survey', track: { scene: 'survey' } }

export default dynamic(getClientModule, { ssr: false })
